export default [
  {
    title: '月份',
    key: 'month',
    fixed: true,
    width: 160
  },
  {
    title: '分数',
    key: 'sumF',
    fixed: true,
    width: 160
  },
  {
    title: '产出人数',
    key: 'peopleNum',
    fixed: true,
    width: 160
  },
  {
    title: '工作天数',
    key: 'workDay',
    width: 160
  },
  {
    title: '平均每天产出',
    key: 'averageDayF',
    width: 160
  },
  {
    title: '人均每月产出',
    key: 'averagePeopleMonthF',
    width: 160
  },
  {
    title: '人均每天产出',
    key: 'averagePeopleDayF',
    width: 160
  }
]
